
function CUserInfo()
{
    CUserInfo.prototype.reset = function()
    {
        this._id = null;
        this.Account = null;
        this.NickName = null;
        this.Birthday = null;
        this.PhoneNo = "";
        this.GiftEnabled = false;
        this.Verified = false;
        this.Blocked = false;
        this.UniPlayInfo = null;
        this.AvatarInfo = null;
        this.GuoZhaoEnabled = false;
        this.UserUseStoreState = 0;
        this.Token = null;
        this.InCoins = 0;
        this.OutCoins = 0;
        this.InTrialCoins = 0;
        this.OutTrialCoins = 0;
        this.InGuoZhaoCoins = 0;
        this.OutGuoZhaoCoins = 0;
        this.InSpecialCoins = 0;
        this.OutSpecialCoins = 0;
        this.InSpecialCoinsA = 0;
        this.OutSpecialCoinsA = 0;
        this.Agent = null;
        this.WainZhus = null;
        this.PaiedAward = null;
        this.GuoZhaoInfo = null;
        this.Permission = 0;
        this.Level = '銀卡';
        this.MaxBuyableScore = 1000000;
        this.BindedMachines = [];
    }

    CUserInfo.prototype.nickName = function()
    {
        return this.NickName ? this.NickName : this.Account;
    }
    
    CUserInfo.prototype.avatarInfo = function()
    {
        return this.AvatarInfo;
    }

    CUserInfo.prototype.parseGuoZhaoInfo = function(strGuoZhao)
    {
        try {
            const obj = strGuoZhao && strGuoZhao.length > 0 ? JSON.parse(strGuoZhao) : null;
            if (obj) {
                this.GuoZhaoInfo = {
                    Lobby: obj.hasOwnProperty("Lobby") ? obj["Lobby"].toString() : this.GuoZhaoInfo.Lobby,
                    DeviceId: obj.hasOwnProperty("DeviceId") ? parseInt(obj["DeviceId"]) : this.GuoZhaoInfo.DeviceId,
                    MachineId: obj.hasOwnProperty("MachineId") ? parseInt(obj["MachineId"]) : this.GuoZhaoInfo.MachineId
                }
            }
            else {
                this.GuoZhaoInfo = null;
            }
            return true;
        }
        catch(error) {
        }
        return false;
    }
    
    CUserInfo.prototype.guoZhaoInfo = function()
    {
        return this.GuoZhaoInfo;
    }
}

module.exports = {
    create: function() {
        const userInfo = new CUserInfo();
        userInfo.reset();
        return userInfo;
    }
};